import React, { useState, useCallback, useImperativeHandle, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import DatePicker from 'react-datepicker';

const DateEditor = forwardRef((props, ref) => {
  const date = props.value.value;

  const [value, setValue] = useState(() => (date && date.isValid() ? date : null));

  const onChange = useCallback(date => {
    setValue(date);
  }, []);

  useImperativeHandle(
    ref,
    () => ({
      getValue() {
        return { ...props.value, value };
      },
      isPopup() {
        return false;
      },
    }),
    [props.value, value],
  );

  return (
    <DatePicker
      className="form-control input-sm"
      dropdownMode="select"
      onChange={onChange}
      popperContainer={({ children }) => createPortal(children, document.body)}
      selected={value}
      showMonthDropdown
      showYearDropdown
    />
  );
});

export default DateEditor;
